var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.7002C8.59995 2.7002 2.69995 8.6002 2.69995 16.0002C2.69995 23.4002 8.69995 29.3002 16 29.3002C23.4 29.3002 29.2999 23.3002 29.2999 16.0002C29.2999 8.6002 23.4 2.7002 16 2.7002ZM17.3 22.7002H14.6V20.0002H17.3V22.7002ZM17.3 17.3002H14.6V9.3002H17.3V17.3002Z",
    fill: "#FF7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warning_orange.51cc6668ff2969131bf76dd605379a25.svg";
export { ForwardRef as ReactComponent };